import type { Translations } from "../types";

const ko: Translations = {
  "meta.title": "국가별 클릭 지도",
  "meta.description":
    "인터랙티브 세계 지도: 국가별 무료 클릭은 물론 Stripe, PayPal, Buy Me a Coffee를 통한 유료 후원도 가능합니다.",

  "app.title": "국가별 클릭 지도",

  "map.intro":
    "지도에서 국가를 클릭하면 무료로 한 표를 줄 수 있고, 재정적인 후원을 보낼 수도 있습니다. 두 가지 모두 아래의 종합 순위표에 반영됩니다. 이 지도는 이 앱 내에서의 후원 현황만을 나타내며, 실제 국가의 부나 GDP를 나타내지 않습니다.",
  "map.verifying": "확인 중……",
  "map.confirmNotRobot": "무료 클릭을 추가하기 전에, 먼저 로봇이 아님을 간단히 확인해 주세요:",
  "map.tryAgain": "다시 시도",
  "map.registeringClick": "클릭을 등록하는 중……",
  "map.selectedCountry": "선택한 국가: {name}",
  "map.selectFirstFeedback": "국가가 선택되었습니다. 무료 클릭을 추가하려면 먼저 아래에서 로봇이 아님을 확인해 주세요.",
  "map.verificationExpired": "인증이 만료되었습니다——로봇이 아님을 다시 확인해 주세요.",
  "map.slowDown": "조금 천천히——다음 클릭 전에 잠시 기다려 주세요.",
  "map.clickFailed": "클릭을 등록하지 못했습니다. 다시 시도해 주세요.",
  "map.clickErrorGeneric": "클릭 등록 중 오류가 발생했습니다.",
  "map.leaderboardHeading": "국가 순위표",
  "map.emptySelection": "지도에서 국가를 선택하여 클릭하거나 후원해 보세요.",
  "map.loadingData": "데이터를 불러오는 중……",

  "worldmap.loadError": "지도를 불러올 수 없습니다.",
  "worldmap.resetZoom": "확대/축소 초기화",
  "worldmap.resetButton": "⤾ 초기화",
  "worldmap.loadingMap": "지도를 불러오는 중……",
  "worldmap.unknownCountry": "알 수 없음",
  "worldmap.ariaClicks": "{name}: {clicks}회 클릭",
  "worldmap.tooltipClicks": "{clicks}회 클릭",

  "legend.fewer": "클릭 적음",
  "legend.more": "클릭 많음",

  "list.empty": "아직 클릭이 없습니다. 첫 번째 클릭의 주인공이 되어 보세요!",
  "list.ariaLabel": "클릭 수 기준 국가 순위표",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY가 설정되어 있지 않습니다——설정 방법은 README를 참고하세요.",
  "human.verificationFailedGeneric": "인증에 실패했습니다.",
  "human.networkError":
    "인증 서버에 연결할 수 없습니다(네트워크 오류)——VITE_SUPABASE_URL, verify-human 배포 여부, ALLOWED_ORIGIN을 확인해 주세요. 자세한 내용은 README/NAVODILA를 참고하세요.",
  "human.verificationFailedRetry": "인증에 실패했습니다. 다시 시도해 주세요.",

  "provider.stripe": "💳 카드(Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "선택한 국가",
  "panel.currentlyRanked": "현재 순위 #{rank}",
  "panel.shareCopied": "복사됨 ✓",
  "panel.shareShared": "공유됨 ✓",
  "panel.shareButton": "🔗 공유",

  "panel.tableClicks": "클릭 수",
  "panel.tableFree": "무료",
  "panel.tablePaid": "유료",
  "panel.rowAllTime": "전체 기간",
  "panel.rowThisYear": "올해",
  "panel.rowThisWeek": "이번 주",
  "panel.rowToday": "오늘",

  "panel.totalCombined": "종합 합계:",
  "panel.totalSupport": "총 후원액:",

  "panel.paymentMethod": "결제 수단",
  "panel.noPaymentMethod": "현재 이용 가능한 결제 수단이 없습니다.",
  "panel.supportAmount": "후원 금액(EUR)",
  "panel.amountRange": "금액은 {min}에서 {max} 사이여야 합니다.",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "예상 유료 클릭 수:",
  "panel.ratioInfo":
    "비율: {a} = {b}클릭(예: {c} = {d}클릭). 이는 결제 전 예상치일 뿐이며——최종 클릭 수는 실제로 확인된 결제 내역을 기준으로 서버에서 항상 계산 및 확정됩니다.",
  "panel.preparing": "준비 중……",
  "panel.continueWith": "{provider}(으)로 계속하기",
  "panel.choosePaymentMethod": "결제 수단 선택",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME이 설정되어 있지 않습니다——설정 방법은 README를 참고하세요.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID가 설정되어 있지 않습니다——설정 방법은 README를 참고하세요.",

  "panel.paypalAmountInfo": "금액: {amount}(예상 {clicks}회 클릭). 아래 PayPal 버튼으로 결제를 완료해 주세요.",
  "panel.back": "← 뒤로",

  "panel.bmcWarningTitle": "⚠️ BuyMeCoffee로 이동하기 전에:",
  "panel.bmcWarningBody":
    "결제 시 메시지/메모란에 아래 코드를 붙여넣어 주세요——이것이 어느 국가를 후원하는지 확인할 수 있는 유일한 방법입니다. 코드가 없으면 결제를 어떤 국가에도 연결할 수 없습니다.",
  "panel.copy": "복사",
  "panel.copied": "복사됨 ✓",
  "panel.suggestedAmount": "추천 금액:",
  "panel.bmcAmountNote":
    "(예상 {clicks}회 클릭). 안타깝게도 BuyMeCoffee는 링크를 통한 금액 전달을 지원하지 않으므로, 해당 사이트에서 직접 금액을 입력하거나 선택해 주세요. 실제 클릭 수는 이 예상치가 아니라 BuyMeCoffee에서 실제로 보낸 금액을 기준으로 계산됩니다.",
  "panel.openBmc": "BuyMeCoffee 열고 계속하기 →",
  "panel.waitingProvider": "결제 제공업체의 결제 확인을 기다리는 중……",
  "panel.waitingConfirmation": "결제 확인을 기다리는 중……",
  "panel.timedOut":
    "확인 시간이 초과되었습니다. 결제를 완료하셨다면, 서버가 확인을 받는 즉시 지도가 업데이트됩니다——다소 시간이 더 걸릴 수 있습니다.",
  "panel.checkAgain": "다시 확인",

  "panel.cancelled": "결제가 취소되었거나 완료되지 않았습니다. 지도에는 변화가 없습니다.",
  "panel.tryAgain": "다시 시도",

  "panel.confirmed": "✅ 후원이 확인되었습니다!",
  "panel.confirmedBody": "{country}이(가) {amount}에 대해 {clicks}회의 유료 클릭을 받았습니다.",

  "panel.errorPreparingSupport": "후원을 준비하는 중 오류가 발생했습니다.",
  "panel.errorPreparingPayment": "결제를 준비하는 중 오류가 발생했습니다.",
  "panel.errorConfirmingPayment": "결제를 확인하는 중 오류가 발생했습니다.",
  "panel.errorPayingPaypal": "PayPal로 결제하는 중 오류가 발생했습니다.",

  "share.unranked": "{flag}{country}에 세계 지도에서 여러분의 후원이 필요합니다!\n순위표를 올릴 수 있도록 도와주세요 👇",
  "share.rank1": "{flag}{country}이(가) 현재 1위입니다!\n함께 1위를 지켜주세요 👇",
  "share.rankN": "{flag}{country}이(가) 현재 #{rank}위입니다!\n함께 1위를 향해 도와주세요 👇",

  "language.switcherLabel": "언어",
};

export default ko;
